import request from '../utils/request';
const querystring = require('querystring') 
//获取列表数据
export const fetchData = query => {  
    var list = request({
        url: 'comTaskList/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
};
 
  

//'保存来源'
export const saveForm = query => { 
    
    var list = request({
        url: 'comTaskList/insert.do',
        method: 'post',
        data: querystring.stringify(query),
    }); 
    return list;
};
 

//启用-禁用 
export const changeStatus = query => {  
    var list = request({
        url: 'comTaskList/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};

export const handDelete = query => {  
    var list = request({
        url: 'comTaskList/delete.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
 
export const handExcute = query => {  
    var list = request({
        url: query.apiUrl,
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};
export const changeForm = query => {  
    var list = request({
        url: 'comTaskList/update.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};


export const fetchSelect = query => {  
    var list = request({
        url: 'comTaskList/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),  
    }); 
    return list;
};







